<template>
    <div>
        <!-- 任選套餐可重複選 -->
        <div class="row_center_end quantity_container" v-if="quantity !== 0">
            <div class="row_center_center quantity">{{ quantity }}</div>
        </div>
        <div class="row_center_between w-full">
            <div class="row_center_center" style="background-color: #DDDDDD; border-radius: 50%; padding: 2px;"
                @click="subtractQuantity">
                <text id="remove" class="button-icon"
                    style="color: #000; font-size: 32px; height: 32px; width: 32px">remove</text>
            </div>

            <div class="row_center_center px-1.5 grow w-0" @click="addQuantity">
                <text class="flex-wrap">{{ product.name }}</text>
            </div>

            <div class="row_center_center" style="background-color: #FBCB02; border-radius: 50%; padding: 2px;"
                @click="addQuantity">
                <text id="add" class="button-icon"
                    style="color: #000; font-size: 32px; height: 32px; width: 32px">add</text>
            </div>
        </div>
        <div class="col_start_end w-full">
            <div class="row_center_end w-full pl-8 my-2" v-for="(product, index) in orderProducts.filter(p => p.productSpecSettings && p.productSpecSettings.length)" :key="product.id">
                <div class="row_center_end grow flex-wrap">
                    <text class="text-[#666666] w-full text-right">{{ customizedText(product) }}</text>
                </div>
                <text id="expand_more" class="button-icon text-[#666666] text-2xl ml-1.5" @click="removeProduct(product, index)">delete</text>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        product: {
            type: Object,
            default: () => {
                return {};
            },
            required: true,
        },
        quantity: {
            type: Number,
            default: 0,
            required: true,
        },
        orderProducts: {
            type: Array,
            default: () => {
                return [];
            },
            required: true,
        }
    },
    methods: {
        customizedText(product) {
            if (product.productSpecSettings === undefined) return '';
            let customizedText = '';
            product.productSpecSettings.forEach(el => {
                if (el.subSpecOptionSelectCount !== undefined) {
                    const totalCount = el.subSpecOptionSelectCount.reduce((acc, option) => acc + option, 0)
                    if (totalCount === 0) return;
                    let text = el.subSpecOptionSelectCount.reduce((text, count, index) => {
                        if (el.specOptions === undefined || count === 0) return text;
                        return text += `${el.specOptions[index].name} ${count > 1 ? `x${count}` : ''}/`;
                    }, '');
                    if (text) {
                        // customizedText += `${el.frontEndDisplayName}：${text.slice(0, -1)}、`;
                        customizedText += `${text.slice(0, -1)}、`;
                    }
                }
            });
            return customizedText ? customizedText.slice(0, -1) : '';
        },
        click() {
            this.$emit("click");
        },
        openCustomizePopup() {
            this.$emit("openCustomizePopup");
        },
        subtractQuantity() {
            this.$emit("subtractQuantity");
        },
        addQuantity() {
            this.$emit("addQuantity");
        },
        removeProduct(product, index) {
            this.$emit("removeProduct", product, index);
        }
    }
}
</script>
<style lang="scss" scoped>
.quantity_container {
    width: 100%;
    height: 0px;
    position: relative;
}

.quantity {
    position: absolute;
    top: -26px;
    right: -32px;
    border-radius: 50%;
    width: 32px;
    height: 32px;
    background-color: #D60A0A;
    flex-shrink: 0;
    color: #fff;
    font-size: 18px;
    font-weight: 500;
    font-family: PingFang SC;
}
</style>